export const BANNER_NAME = 'JPD_PREMIUM_ONBOARDING_BANNER';

export const BANNER_HEIGHT = 40;
export const MIN_BANNER_WIDTH = 320;

export const ENTRY_POINT_ID = 'jira.polaris.premium-onboarding-banner';
export const PACKAGE_NAME = 'jiraPolarisComponentPremiumOnboardingBanner';
